import React, { useState } from 'react';
import { Collapse, Image, Table, Typography, Space } from 'antd';
import alpha from 'color-alpha';
import styles from '../../../Components/ExpansionPanel/ExpansionPanel.module.scss';
import { Icon } from '@iconify/react';
import styled from 'styled-components';
import schedule from "@assets/KPMG/assets/schedule.png";
import mda from "@assets/KPMG/assets/mda.png";

const { Panel } = Collapse;

interface AccordionPanelProps {
    title: string;
    data: { title: string; value: string | number }[];
}

interface AccordionTableProps {
    panels: AccordionPanelProps[];
}
const StyledIcon = styled(Icon)`
  height: 24px;
  width: 24px;
  padding: 5px;
  border-radius: 100% !important;
  const { Panel } = Collapse;
`;
const AccordionTable: React.FC<AccordionTableProps> = ({ panels }) => {
    const formatValue = (value: string | number) => {
        if (typeof value === 'number') {
            return value.toLocaleString();
        }
        return value;
    };
    const [activePanel, setActivePanel] = useState(['0']); // Initially set the first panel as active

    return (
        <Collapse
            defaultActiveKey={activePanel}
            accordion
            destroyInactivePanel
            expandIconPosition="end"
            style={{
                backgroundColor: 'transparent',
                border: "none"
            }}
            className='drilldown-collapse'
            expandIcon={(props) => {
                return (
                    <StyledIcon
                        fontSize={20}
                        fontWeight="bold"
                        icon="akar-icons:chevron-down"
                        style={{
                            color: "#FD349C",
                            background: alpha(styles.strawberry, 0.2),
                        }}
                        // {...props}
                        rotate={props.isActive ? "180deg" : 0}
                    />
                );
            }}
        >
            {panels.map((panel, index) => (
                <Panel
                    header={panel.title}
                    className={'text'}
                    key={index}
                    style={{
                        border: `1px solid #fd349c`,
                        borderRadius: 8,
                        marginBottom: 16,
                        padding: 16,
                        fontWeight: 'bold',
                        color: '#003087'
                    }}
                >
                    {index != 1 ?
                        <Table
                            dataSource={panel.data}
                            columns={[
                                {
                                    title: 'Title',
                                    dataIndex: 'title',
                                    key: 'title',
                                    render: (value: any, record: any) => (
                                        <Typography.Text className={'textSmall'} style={{ color: '#636363' }}>{value}</Typography.Text>
                                    ),
                                },
                                {
                                    title: 'Value',
                                    dataIndex: 'value',
                                    key: 'value',
                                    render: (value: any) => (
                                        <div>
                                            {value.split('\n').map((line: any, index: number) => (
                                                <div key={index}>
                                                    <Typography.Text className={'textSmall'} style={{ color: '#1E49E2' }}>{formatValue(line)}</Typography.Text>
                                                </div>
                                            ))}
                                        </div>
                                    ),
                                },
                            ]}
                            showHeader={false}
                            pagination={false}
                        />
                        :
                        <Space direction='vertical'>
                            <Image
                                src={schedule}
                                preview={false}
                            />
                            <Image
                                src={mda}
                                preview={false}

                            />
                        </Space>
                    }

                </Panel>
            ))}
        </Collapse>

    );
};

export default AccordionTable;
